import React, {useEffect, useState} from 'react'
import {Button, Modal, Popconfirm, Spin} from "antd"
import {getUserPackage} from "../../../../../services/api/apiTransaction";
import parseToken from "../../../../../helpers/parseToken";

const UserPackagePopup = (props) => {
    const {showModal, toggleModal} = props
    const [userPackage, setUsePackage] = useState({})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const info = parseToken()

    const _getUserPackage = async () => {
        setLoading(true)
        setError('')
        try {
            const payload = {}
            const response = await getUserPackage(info.sub, payload)
            const {success, data, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }
            setLoading(false)
            setUsePackage(data)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const handleCancel = () => {
        toggleModal()
    }

    useEffect(() => {
        _getUserPackage()
        // eslint-disable-next-line
    }, [])

    return <>
        <Modal
            title="Thông tin gói"
            className="ModalCustom2 FormEdit"
            maskClosable={false}
            visible={showModal}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link">
                            Cancel
                        </Button>
                    </Popconfirm>
                </div>
            ]}
        >
            <div className="FormAddNew">
                <Spin spinning={loading} tip="Đang lấy dữ liệu...">
                    {error ? <div className="text-danger">{error}</div> : <table className="table">
                        <thead className="TableHead">
                        <tr>
                            <th className="">Gói cước</th>
                            <th className="">Thuộc tính</th>
                            <th className="">Giá trị</th>
                        </tr>
                        </thead>
                        <tbody className="TableBody">
                        {
                            !!userPackage && userPackage.length > 0 ? userPackage.map((item, index) => {
                                return <tr key={index}>
                                    <td>{item.packages}</td>
                                    <td>{item.description}</td>
                                    <td>{item.value}</td>
                                </tr>
                            }) : <tr className="NoRecord">
                                <td colSpan={3}>Không có bản ghi nào</td>
                            </tr>
                        }
                        </tbody>
                    </table>}
                </Spin>
            </div>
        </Modal>
    </>
}

export default UserPackagePopup
